import { UserState } from './ducks';

const getRootUserState = (state): UserState => state.user;

export const getUser = getRootUserState; /* eslint-disable-line */

export const isUserLoggedIn = (state?: UserState): boolean => state?.token != null;
